import { useState, useEffect, useCallback } from 'react';
import type { Step, StepInfo } from '../../services/types';
import type { Steps as SellersHubSteps, StepInfo as SellersHubStepInfo } from '../../services/registration-sellers-types';

const ANIMATION_DURATION = 1360;

type HubCongratsProps = {
  animatedCongratsStep: Step | SellersHubSteps | undefined,
  step: StepInfo | SellersHubStepInfo,
  callback?: () => void,
}

export const useHubCongrats = (props: HubCongratsProps) => {
  const { step, animatedCongratsStep, callback } = props;
  const [isLoadingCongratsStep, setIsLoadingCongratsStep] = useState<boolean>(!!animatedCongratsStep);
  const [congratsStepClassName, setCongratsClassName] = useState<string>(step.id === animatedCongratsStep ? 'pending' : step.status);
  const isCongratsStep = (step.status === 'completed' || step.status === 'conflict') && animatedCongratsStep === step.id;

  const iconColorByStatus = useCallback((animationTrigger: boolean) => (isCongratsStep && animationTrigger ? 'loading' : step.status), [step, animatedCongratsStep]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (animatedCongratsStep) {
      setIsLoadingCongratsStep(true);
      setCongratsClassName(iconColorByStatus(true));

      timeoutId = setTimeout(() => {
        setIsLoadingCongratsStep(false);
        setCongratsClassName(iconColorByStatus(false));
      }, ANIMATION_DURATION);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [animatedCongratsStep, step.status]);


  return {
    isLoadingCongratsStep,
    congratsStepClassName,
    isCongratsStep,
  };
};
